import RootStore from 'stores/RootStore'
import { getEnv } from 'utils/env'
import { TenantUuid } from '@finanzcheck/marta-mui-theme'
import { StartupCommand } from './command.interface'

class InitTheme implements StartupCommand {
  name = 'InitTheme'
  dependencies = []
  timeout = 10000

  execute = async (rootStore: RootStore) => {
    const tennantUUID =
      getEnv('REACT_APP_TENANT_UUID') === TenantUuid.Smava
        ? TenantUuid.Smava
        : TenantUuid.FinanzcheckLive
    const { fetchTheme } = rootStore.theme
    fetchTheme(tennantUUID)
  }
}

export default InitTheme
